import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { API_PATH } from '@constant/api-path.constant';
import { PATH } from '@constant/path.constant';
import { LoadingComponent } from '@shared/components/loading/loading.component';
import { NoDataComponent } from '@shared/components/no-data/no-data.component';
import { PaginationComponent } from '@shared/components/pagination/pagination.component';
import {
  GetListResponse,
  GetListService,
  ListData,
} from '@shared/service/api/get-list/get-list.service';
import { PageStateService } from '@shared/service/page-state.service';
import { Observable, switchMap, tap } from 'rxjs';

@Component({
  selector: 'app-pet-list',
  standalone: true,
  imports: [
    CommonModule,
    PaginationComponent,
    RouterModule,
    LoadingComponent,
    NoDataComponent,
  ],
  templateUrl: './pet-list.component.html',
  styleUrl: './pet-list.component.scss',
})
export class PetListComponent {
  private router = inject(Router);
  private getListService = inject(GetListService);
  private route = inject(ActivatedRoute);
  private pageStateService = inject(PageStateService);
  protected category = '';
  protected isApiLoading = false;
  pageSize = 12;
  list: { catObj: ListData }[] = [];
  dataSize = 0;
  constructor() {
    this.route.paramMap
      .pipe(
        tap((res) => {
          this.category = res.get('category') || '';
          this.list = [];
        }),
        switchMap(() =>
          this.listApi$(this.category, this.pageStateService.page)
        )
      )
      .subscribe();
  }
  toDetail(id: string) {
    this.router.navigate([`${PATH.petDetail(this.category, id)}`]);
  }
  changePage(currentPage: number) {
    this.listApi$(this.category, currentPage).subscribe();
  }

  listApi$(id: string, pageidx: number): Observable<GetListResponse> {
    this.isApiLoading = true;
    return this.getListService
      .getListApi(API_PATH.getList, {
        catSort: id,
        catInPage: String(this.pageSize),
        pageidx: String(pageidx - 1),
      })
      .pipe(
        tap((data) => {
          this.list = data.catInfoObj;
          this.dataSize = data.catQty;
          this.isApiLoading = false;
        })
      );
  }
}
